angular.module('tgaAdmin')
  .service('orderService', ['$http', 'envService', 'domainService',
    function ($http, envService, domainService) {
      const serverAddress = envService.read('serverAddress');

      function getOrders(startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}order`,
          params: {
            domain: domainService.domain,
            start_date: startDate ? new Date(startDate) : null,
            end_date: endDate ? new Date(endDate) : null,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      // -- AVATAX METHODS --

      /**
       * Create Transaction.
       * @param data All the fields for customer and transaction methods.
       * @return TransactionModel (json-encoded) or null on error.
       */
      function postTransaction(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}order/transaction`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      /**
       * Commit Transaction.
       * @param data Transaction fields, to update existing transaction before committing.
       * @return transaction object with commited = true
       */
      function postCommit(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}order/commit`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getOrders,
        postTransaction,
        postCommit,
      });
    }]);
